var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef } from "react";
import { Box, HStack, ScrollView, VStack } from "native-base";
import { isWeb } from "@madmedical/utils";
import { useTranslation } from "@madmedical/i18n";
import Paper from "../../../atoms/Paper";
import Headline from "../../../molecules/Headline";
import Breadcrumb from "../../../molecules/Breadcrumb";
import Button from "../../../atoms/Button";
import IconButton from "../../../atoms/IconButton";
import useResponsive from "../../../util/useResponsive";
import PreOpNextButton from "./PreOpNextButton";
const PreOpWrapper = (_a) => {
    var { children, isLastScreen = false, isSubmitting = false, isNextDisabled = false, onPreviousPress, onNextPress, title = "Altatás előtti kérdőív", validate } = _a, rest = __rest(_a, ["children", "isLastScreen", "isSubmitting", "isNextDisabled", "onPreviousPress", "onNextPress", "title", "validate"]);
    const { isSmallScreen } = useResponsive();
    const scrollViewRef = useRef();
    const { t } = useTranslation();
    const nextButtonLabel = isSubmitting
        ? t("save")
        : isLastScreen
            ? t("ok")
            : isSmallScreen
                ? t("continue")
                : t("next");
    const scrollToTop = () => {
        var _a;
        if (isWeb) {
            window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
        }
        else {
            (_a = scrollViewRef.current) === null || _a === void 0 ? void 0 : _a.scrollTo({ x: 0, y: 0, animated: true });
        }
    };
    const handlePrevPress = () => {
        if (!onPreviousPress)
            return;
        scrollToTop();
        onPreviousPress();
    };
    const handleNextPress = () => {
        var _a;
        (_a = scrollViewRef.current) === null || _a === void 0 ? void 0 : _a.scrollTo({ x: 0, y: 0, animated: true });
        scrollToTop();
        onNextPress();
    };
    return (_jsxs(Paper, Object.assign({ justifyContent: "space-between", alignItems: "flex-start", height: "full", flex: 1 }, rest, { children: [_jsx(Headline, { minHeight: 12, borderBottomWidth: 1, borderBottomColor: "gray.100", borderBottomStyle: "solid", leftContent: _jsxs(Breadcrumb, { children: [_jsx(Breadcrumb.Item, { children: _jsx(Breadcrumb.Link, Object.assign({ route: "dashboard", params: {} }, { children: t("health") })) }), _jsx(Breadcrumb.Item, { children: _jsx(Breadcrumb.Text, { children: title }) })] }) }), _jsx(Headline, { justifyContent: "center", alignItems: "center", borderBottomWidth: 1, borderBottomColor: "gray.100", borderBottomStyle: "solid", title: title }), _jsx(ScrollView, Object.assign({ w: "full", ref: scrollViewRef }, { children: _jsx(VStack, Object.assign({ width: "full", flex: 1 }, { children: children })) })), _jsxs(HStack, Object.assign({ width: "full", px: 6, py: 4, justifyContent: "space-between", borderTopWidth: 1, borderTopColor: "gray.100", space: 2 }, { children: [onPreviousPress ? (isSmallScreen ? (_jsx(IconButton, { iconName: "arrowLeft", size: "md", onPress: handlePrevPress, variant: "outlined" })) : (_jsx(Button, Object.assign({ size: "md", variant: "outlined", onPress: handlePrevPress }, { children: "Vissza" })))) : (
                    // TODO: Replace Box with null and implement a better solution for alignment
                    _jsx(Box, {})), validate ? (_jsx(PreOpNextButton, { isSubmitting: isSubmitting, isDisabled: isNextDisabled, onPress: handleNextPress, validate: validate, label: nextButtonLabel })) : (_jsx(Button, Object.assign({ size: "md", isDisabled: isNextDisabled, isLoading: isSubmitting, isLoadingText: `${nextButtonLabel}…`, onPress: handleNextPress, flex: isSmallScreen ? 1 : "unset" }, { children: nextButtonLabel })))] }))] })));
};
export default PreOpWrapper;
